import PropTypes from 'prop-types'
import { Box, CoverImage, Text, Link } from '@redriverpress/system'

import styled from 'styled-components'
import { CONTENT_LABELS } from 'Common/constants/contentTypes'

const ContentBox = styled(Link).attrs({
  bg: 'white',
  display: 'flex',
  alignItems: ['flex-start', null, 'center'],
  borderRadius: 'medium',
  p: 3,
  mb: 2,
})`
  width: 100%;
  cursor: pointer;
  &:focus {
    outline: none;
  }

  &:focus,
  &:focus-visible {
    box-shadow: 0 0 0 2px ${props => props.theme.colors.blue500};
  }

  &:after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: ${props => props.theme.radii.rounded};
    box-shadow: ${props => props.theme.shadows[3]};
    opacity: 0;
    transition: 0.15s ease-in;
  }

  &:hover:after,
  &:focus:after {
    opacity: 1;
  }
`

const Label = styled(Text)`
  text-decoration: underline;
  text-decoration-color: ${props => props.theme.colors.blue700};
  text-underline-position: under;
  width: fit-content;
`

const coverImageSize = '3rem'

const materialLabel = content => {
  return content.course_content_type === 'assessment'
    ? `Assessment`
    : CONTENT_LABELS[content.content.type]
}

export default function MaterialsRow({ content }) {
  return (
    <ContentBox href={content.content.path} position='relative' reset>
      <Box display='flex' alignItems='center' mr={3} my='auto'>
        <Box pr={3} fontWeight='600'>
          {content.position}.
        </Box>
        <CoverImage
          size={coverImageSize}
          src={content.content.thumbnail_url || content.content.image}
          flex='none'
          alt=''
        />
      </Box>
      <Box>
        <Text color='gray700' mb={0} fontWeight='600'>
          {materialLabel(content)}
        </Text>
        <Label mt={0} fontWeight='600'>
          {content.content.title}
        </Label>
      </Box>
    </ContentBox>
  )
}

MaterialsRow.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    image: PropTypes.string,
    thumbnail_url: PropTypes.string,
  }).isRequired,
}
